import { Query } from "../types/graphql-types";

export const getTranslations = (data: Query) => {
    const nodes = data.allContentfulTranslation!.edges!.map(e => e!.node!)
    const map = new Map<string, string>()
  
    for (const node of nodes) {
      if (!node.key || !node.value) {
        continue; // log error?
      }
      map.set(node.key, node.value);
    }
    return map;
  }